import type { ScheduleSession } from '@entities/schedules/schedule/types.ts';
import type React from 'react';
import { EmptyEditorSession } from '@features/shedules/index.ts';

const doCalcMinutesReminder = (date: Date, divisionValue: number) => {
  return date.getMinutes() % divisionValue;
};
export const doCalc15MinutesReminder = (date: Date) => doCalcMinutesReminder(date, 15);
export const getCurrentTimeWithReminder15 = (date: Date, dateWithReminder: Date) => {
  const dateClone = structuredClone(date);
  return new Date(
    dateClone.setMinutes(dateClone.getMinutes() + doCalc15MinutesReminder(dateWithReminder))
  );
};

export const scheduleSteps = [0, 1, 2];

export type DoRenderEmptySessionType = {
  session: ScheduleSession;
  onEmptyClick: (session: ScheduleSession) => void;
  onEmptyHover: (e: React.MouseEvent<HTMLDivElement, MouseEvent>, session: ScheduleSession) => void;
  hide: () => void;
};

export const doRenderEmptySession = ({
  session,
  onEmptyClick,
  onEmptyHover,
  hide,
}: DoRenderEmptySessionType) => {
  return scheduleSteps.map((step) => (
    <EmptyEditorSession
      key={String(session.start) + step}
      start={session.start}
      end={session.end}
      onMouseOver={(e) => {
        session.start.setMinutes(session.start.getMinutes() + step * 5);
        session.end.setMinutes(session.end.getMinutes() - step * 5);
        onEmptyHover(e, session);
      }}
      onClick={() => onEmptyClick(session)}
      onMouseLeave={() => {
        session.start.setMinutes(session.start.getMinutes() - step * 5);
        session.end.setMinutes(session.end.getMinutes() + step * 5);
        hide();
      }}
    />
  ));
};
